import { useEffect, useState } from "react";
import { CloudOff, Hourglass, RefreshCw, LogIn } from "lucide-react";
import { subscribeSync } from "@/lib/offline";

// Subtle bottom pill shown whenever the app is offline or holding unsynced changes —
// field crews always know their clock-ins and photos are safe on the device.
export const SyncIndicator = () => {
  const [s, setS] = useState({ online: true, slow: false, pending: 0, draining: false, authBlocked: false });
  useEffect(() => subscribeSync(setS), []);

  if (s.online && !s.slow && s.pending === 0) return null;

  return (
    <div
      data-testid="sync-indicator"
      style={{ bottom: "calc(var(--bottom-bar-h, 0px) + 1rem)" }}
      className="fixed left-1/2 -translate-x-1/2 z-[130] w-max max-w-[calc(100vw-2rem)] flex items-center [&>svg]:shrink-0 gap-2 bg-navy/95 backdrop-blur text-white text-xs font-medium rounded-full pl-3 pr-4 py-2 shadow-lg border border-white/10"
      role="status"
    >
      {!s.online ? (
        <>
          <CloudOff className="h-3.5 w-3.5 text-amber-400" />
          <span data-testid="sync-indicator-text">
            {s.pending > 0
              ? `No signal — ${s.pending} change${s.pending === 1 ? "" : "s"} saved on this device, will sync automatically`
              : "No signal — working offline"}
          </span>
        </>
      ) : s.slow ? (
        <>
          <Hourglass className="h-3.5 w-3.5 text-amber-400" />
          <span data-testid="sync-indicator-text">
            {s.pending > 0
              ? `Server is slow — ${s.pending} change${s.pending === 1 ? "" : "s"} saved on this device, will sync automatically`
              : "Server is slow — retrying"}
          </span>
        </>
      ) : s.authBlocked ? (
        <>
          <LogIn className="h-3.5 w-3.5 text-amber-400" />
          <span data-testid="sync-indicator-text">Sign in again to sync {s.pending} saved change{s.pending === 1 ? "" : "s"}</span>
        </>
      ) : (
        <>
          <RefreshCw className={`h-3.5 w-3.5 text-emerald-400 ${s.draining ? "animate-spin" : ""}`} />
          <span data-testid="sync-indicator-text">
            {s.draining ? "Syncing saved changes…" : `${s.pending} change${s.pending === 1 ? "" : "s"} waiting to sync`}
          </span>
        </>
      )}
    </div>
  );
};
